import { Link } from 'react-router-dom';

const pillars = [
  { n: '01', t: 'The hide', d: 'We source full-grain, vegetable-tanned leather from a single tannery in Surat. Slow-tanned in pits over 30–45 days.' },
  { n: '02', t: 'The cut', d: 'Every panel is cut by hand from paper patterns. It is slower, and it wastes less.' },
  { n: '03', t: 'The stitch', d: 'A double-needle saddle stitch, waxed for water resistance. Should a stitch break, the rest hold firm.' },
  { n: '04', t: 'The finish', d: 'Edges are sanded, dyed, and burnished by hand — sometimes four to five passes over.' }
];

export default function OurStory() {
  return (
    <main>
      {/* Hero */}
      <section className="relative min-h-[70vh] flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <img src="https://images.pexels.com/photos/4452610/pexels-photo-4452610.jpeg" alt="Artisan at work" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-black/45" />
        </div>
        <div className="relative max-w-4xl mx-auto px-6 text-[#F4EEE4] text-center py-24">
          <p className="text-[11px] tracking-widest-plus uppercase mb-6 text-[#E8A76B]">Our Story</p>
          <h1 className="font-serif-display text-5xl md:text-7xl leading-[1.05] mb-8">
            The slow business<br />of making things well.
          </h1>
          <p className="text-lg max-w-2xl mx-auto opacity-90">
            barebasics began in a two-room workshop in 2018, with two artisans, one sewing machine, and the belief that everyday objects deserve to be beautifully made.
          </p>
        </div>
      </section>

      {/* Intro */}
      <section className="max-w-3xl mx-auto px-6 py-24 text-center">
        <p className="text-[11px] tracking-widest-plus uppercase text-[#C6410E] mb-6">A quiet manifesto</p>
        <p className="font-serif-display text-3xl md:text-4xl leading-snug mb-8">
          &ldquo;We believe the small objects on your desk, in your bag, or in your pocket should be as considered as the room they live in.&rdquo;
        </p>
        <p className="text-[#1a1a1a]/70">— The founders</p>
      </section>

      {/* Pillars */}
      <section className="bg-[#E9E1D4]">
        <div className="max-w-7xl mx-auto px-6 py-24">
          <div className="mb-16 max-w-2xl">
            <p className="text-[11px] tracking-widest-plus uppercase text-[#C6410E] mb-4">Craftsmanship</p>
            <h2 className="font-serif-display text-4xl md:text-5xl">Four hands, four steps.</h2>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
            {pillars.map(p => (
              <div key={p.n} className="border-t border-black/25 pt-6">
                <p className="font-serif-display text-5xl text-[#C6410E] mb-6">{p.n}</p>
                <h3 className="font-serif-display text-2xl mb-3">{p.t}</h3>
                <p className="text-sm text-[#1a1a1a]/75 leading-relaxed">{p.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Split image feature */}
      <section className="grid md:grid-cols-2">
        <div className="aspect-[4/5] md:aspect-auto min-h-[60vh] overflow-hidden">
          <img src="https://images.pexels.com/photos/11676700/pexels-photo-11676700.jpeg" alt="Stitching leather by hand" className="w-full h-full object-cover" />
        </div>
        <div className="bg-[#1a1a1a] text-[#F4EDDF] flex items-center px-6 md:px-16 py-24">
          <div>
            <p className="text-[11px] tracking-widest-plus uppercase text-[#E8A76B] mb-6">The Workshop</p>
            <h2 className="font-serif-display text-4xl md:text-5xl leading-tight mb-8">A house of nine, in Surat.</h2>
            <p className="text-lg opacity-80 leading-relaxed mb-6">
              Our workshop sits on the first floor of a quiet lane, above a tea shop that has been there longer than any of us. Inside, nine artisans work at low benches, in daylight, without music.
            </p>
            <p className="text-lg opacity-80 leading-relaxed">
              We do not have targets. We have a queue, and we work through it, one piece at a time.
            </p>
          </div>
        </div>
      </section>

      {/* Numbers */}
      <section className="max-w-7xl mx-auto px-6 py-24 grid grid-cols-2 md:grid-cols-4 gap-10 text-center">
        {[
          { n: '7 yrs', l: 'In practice' },
          { n: '9', l: 'Artisans' },
          { n: '1', l: 'Workshop' },
          { n: '∞', l: 'Lifetime repair' }
        ].map(s => (
          <div key={s.l}>
            <p className="font-serif-display text-6xl md:text-7xl text-[#C6410E]">{s.n}</p>
            <p className="text-[11px] tracking-widest-plus uppercase text-[#1a1a1a]/60 mt-3">{s.l}</p>
          </div>
        ))}
      </section>

      {/* CTA */}
      <section className="bg-[#E9E1D4]">
        <div className="max-w-4xl mx-auto px-6 py-24 text-center">
          <h2 className="font-serif-display text-4xl md:text-5xl mb-6">Come, take your time.</h2>
          <p className="text-[#1a1a1a]/70 mb-10 max-w-xl mx-auto">
            Browse the collection at your own pace, or write to us with a question, however small.
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <Link to="/shop" className="btn-primary">Explore the collection</Link>
            <Link to="/contact" className="btn-ghost">Contact us</Link>
          </div>
        </div>
      </section>
    </main>
  );
}
